// extracted by mini-css-extract-plugin
module.exports = {"pro-profile-case-study":"ProCaseStudyContent_pro-profile-case-study__ypK2f"};